import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import XeroConnectionTab from "@/components/admin/XeroConnectionTab";
import XeroOrganisationsTab from "@/components/admin/XeroOrganisationsTab";
import XeroPipelineTab from "@/components/admin/XeroPipelineTab";
import XeroMappingsTab from "@/components/admin/XeroMappingsTab";

const TAB_VALUES = ["connection", "organisations", "mappings", "pipeline"] as const;
type TabValue = (typeof TAB_VALUES)[number];


const XeroIntegrationSection = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const tab: TabValue = TAB_VALUES.includes(tabParam as TabValue)
    ? (tabParam as TabValue)
    : "connection";

  const setTab = (next: string) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", next);
      return params;
    });
  };

  return (
    <Tabs value={tab} onValueChange={setTab}>
      <TabsList className="mb-4">
        <TabsTrigger value="connection">Connection</TabsTrigger>
        <TabsTrigger value="organisations">Organisations</TabsTrigger>
        <TabsTrigger value="mappings">Mappings</TabsTrigger>
        <TabsTrigger value="pipeline">Pipeline</TabsTrigger>
      </TabsList>

      <TabsContent value="connection" className="focus-visible:outline-none">
        <XeroConnectionTab />
      </TabsContent>

      <TabsContent value="organisations" className="focus-visible:outline-none">
        <XeroOrganisationsTab />
      </TabsContent>

      <TabsContent value="mappings" className="focus-visible:outline-none">
        <XeroMappingsTab />
      </TabsContent>

      <TabsContent value="pipeline" className="focus-visible:outline-none">
        <XeroPipelineTab />
      </TabsContent>
    </Tabs>
  );
};

export default XeroIntegrationSection;
